export default "__VITE_ASSET__Bl8569Pd__"